import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class TickerService {
    async fetch(page, pageSize, search) {
        const pageParam = `page=${page}&perPage=${pageSize}`
        const response = await ajaxService.get(`/ticker-messages?${pageParam}`);
        if (response ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async fetchLoginPageTicker() {
        return await ajaxService.get(`/login-page-ticker`);
    };


    async add(data) {
        const response = await ajaxService.post(`/ticker-messages`, data);
        if (response.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }
    async update(id, data) {
        const response = await ajaxService.put(`/ticker-messages/`, id, data);
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async delete(id) {
        const response = await ajaxService.delete(`/ticker-messages/`, id);
        if (response ?? false) {
            return response;
        }

    }
}

const tickerService = new TickerService();
export default tickerService;
